export const ADD_PROFESSION_REQUEST = 'ADD_PROFESSION_REQUEST'
export const ADD_PROFESSION_SUCCESS = 'ADD_PROFESSION_SUCCESS'
export const ADD_PROFESSION_FALIURE = 'ADD_PROFESSION_FALIURE'
